/**
 * Si es un subtotal el valor hasSeries deben ser false. Ej DonutChart.
 *
 * @param {object} userStats
 * @param {boolean} hasSeries
 * @returns {boolean}
 */

export const showAnonymousLeads = (userStats = {}, hasSeries = true) => {
  if (!hasSeries) return userStats && userStats.anonymous && userStats.anonymous > 0;
  return userStats && userStats.anonymous && userStats.anonymous.filter(anonymous => anonymous > 0).length > 0;
};
